export enum IntegrationMapItemCode {
	Yandex = 'yandex',
	Gis = 'gis',
}

export enum IntegrationMapItemStatus {
	Connected = 'connected',
	NotConnected = 'not_connected',
	InProgress = 'in_progress',
}
